export const PEDA_CATEGORY_KEYS = [
  'hameconnage',
  'manipulation',
  'incidents',
  'donnees',
  'appareils',
  'acces',
] as const;

export type PedaCategoryKey = (typeof PEDA_CATEGORY_KEYS)[number];

export const PEDA_CATEGORY_LABELS: Record<PedaCategoryKey, string> = {
  hameconnage: 'Lutter contre le hameçonnage',
  manipulation: 'Contre-manipulation',
  incidents: 'Gérer les incidents',
  donnees: 'Protéger les données',
  appareils: 'Sécuriser les appareils',
  acces: 'Renforcer l\'accès',
};

/** Libellés courts pour les tuiles de fin de chapitre. */
export const PEDA_CATEGORY_SHORT_LABELS: Record<PedaCategoryKey, string> = {
  hameconnage: 'Hameçonnage',
  manipulation: 'Manipulation',
  incidents: 'Signalement',
  donnees: 'Données',
  appareils: 'Appareils',
  acces: 'Accès et badges',
};

/** Ordre des tuiles (maquette fin de chapitre). */
export const PEDA_CATEGORY_TILE_KEYS: PedaCategoryKey[] = [
  'hameconnage',
  'manipulation',
  'acces',
  'incidents',
  'appareils',
  'donnees',
];

const LEGACY_PEDA_CATEGORY_MAP: Record<string, PedaCategoryKey> = {
  'Vigilance Messagerie': 'hameconnage',
  'Ingénierie Sociale': 'manipulation',
  'Contrôle des Accès': 'acces',
  'Réflexes Incidents': 'incidents',
  'Sécurité Physique': 'appareils',
  'Exposition des Données': 'donnees',
  'messagerie — Vigilance Messagerie': 'hameconnage',
  'social — Ingénierie Sociale': 'manipulation',
  'acces — Contrôle des Accès': 'acces',
  'incidents — Réflexes Incidents': 'incidents',
  'physique — Sécurité Physique': 'appareils',
  'donnees — Exposition des Données': 'donnees',
};

export function isValidPedaCategory(value: unknown): value is PedaCategoryKey {
  return typeof value === 'string' && (PEDA_CATEGORY_KEYS as readonly string[]).includes(value);
}

export function normalizePedaCategory(value: unknown): PedaCategoryKey | null {
  if (isValidPedaCategory(value)) return value;
  if (typeof value === 'string' && LEGACY_PEDA_CATEGORY_MAP[value]) {
    return LEGACY_PEDA_CATEGORY_MAP[value];
  }
  return null;
}

export function getPedaCategoryLabel(key: string | null | undefined): string {
  if (!key) return 'Compétence cyber';
  if (isValidPedaCategory(key)) return PEDA_CATEGORY_LABELS[key];
  const normalized = normalizePedaCategory(key);
  if (normalized) return PEDA_CATEGORY_LABELS[normalized];
  return key;
}
